// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PqzT","option":"styles_option__1wg4b","active":"styles_active__tLcGd"};